import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const toneClass = {
    card: 'border-[color:var(--border-card)] bg-[var(--surface-card)]',
    panel: 'border-transparent bg-[var(--surface-panel)]',
    rail: 'border-[color:var(--border-default)] bg-[var(--surface-rail)]',
    sunken: 'border-transparent bg-muted'
};
const elevationClass = {
    none: '',
    xs: 'shadow-[var(--shadow-xs)]',
    sm: 'shadow-[var(--shadow-sm)]',
    md: 'shadow-[var(--shadow-md)]'
};
const paddingClass = {
    none: '',
    sm: 'p-[var(--space-4)]',
    md: 'p-[var(--space-6)]',
    lg: 'p-[var(--space-8)]'
};
const radiusClass = {
    sm: 'rounded-[var(--radius-sm)]',
    md: 'rounded-[var(--radius-md)]',
    lg: 'rounded-[var(--radius-lg)]',
    xl: 'rounded-[var(--radius-xl)]'
};
/** Single branded surface primitive used by cards, panels, and rails. */ export const SpecraSurface = /*#__PURE__*/ React.forwardRef(({ className, elevation = 'none', interactive = false, onKeyDown, padding = 'none', radius = 'lg', role, tabIndex, tone = 'card', ...props }, ref)=>{
    const resolvedRole = role ?? (interactive ? 'button' : undefined);
    return(// biome-ignore lint/a11y/noStaticElementInteractions: interactive surfaces receive button semantics and keyboard activation below.
    /*#__PURE__*/ _jsx("div", {
        className: cn('border', radiusClass[radius], toneClass[tone], elevationClass[elevation], paddingClass[padding], interactive && 'cursor-pointer transition-[box-shadow,transform] duration-[var(--dur-base)] ease-[var(--ease-standard)] hover:-translate-y-px hover:shadow-[var(--shadow-md)]', className),
        onKeyDown: (event)=>{
            onKeyDown?.(event);
            if (interactive && resolvedRole === 'button' && !event.defaultPrevented && event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                event.currentTarget.click();
            }
        },
        ref: ref,
        role: resolvedRole,
        tabIndex: tabIndex ?? (interactive ? 0 : undefined),
        ...props
    }));
});
SpecraSurface.displayName = 'SpecraSurface';
